import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

let i18n = new VueI18n({
  // locale : navigator.language || navigator.userLanguage,
  locale: localStorage.getItem('language') || 'zh', //使用localstorage缓存到本地，当下次使用时可默认当前使用语言
  messages: {
    'zh': {
      ...zh
    },
    'en': {
      ...en
    }
  }
})
locale.i18n((key, value) => i18n.t(key, value))
export default i18n;